import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { SupplierService } from '../../../core/services/supplier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { DriverService } from '../../../core/services/driver.service';
import { BehaviorSubject } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-view-single-supplier',
  templateUrl: './view-single-supplier.component.html',
  styleUrls: ['./view-single-supplier.component.scss'],
})
export class ViewSingleSupplierComponent implements OnInit {
  searchText: any;
  breadcrumbs: any[] = [];
  driverData: any[] = [];
  note = 'This is a sample Note';
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  currentPageIndex = 1;
  pageSizeVeh = 5;
  selectedImage = '';
  isVisible = false;
  supplierData = {
    paymentAttachment: [
      {
        name: '',
        url: '',
      },
    ],
    supplierDetails: {
      name: '',
      email: '',
      mobileNo: '',
    },
    paymentDetails: {
      accountNo: '',
      accountType: '',
      bankName: '',
      branch: '',
      holderName: '',
    },
    vehicles: [],
    supplierId: '',
  };
  supplierId: any;

  skeletonTableColumns: any[] = [
    'Driver Id',
    'Driver Name',
    'Contact Number',
    'Registered/Unregistered',
    'Created Date',
    'Actions',
  ];
  loading = false;

  //Add vehicle stuff
  isVisibleAddVehicle = false;
  vehicles: any[] = [];
  // Add a property to store the paginated vehicles
  paginatedVehicles: any[] = [];
  searchTextTour: any;
  statusFilter: any;
  dateFilter: any;
  pageSizeTour = new PageSize();
  sortFieldTour: any;
  sortOrderTour: any = -1;
  bookingData: any[] = [];
  skeletonTableColumnsTour: any[] = [
    'Booking ID',
    'Booking Type',
    'Driver Name',
    'Booking Start Date and Time',
    'Booking End Date and Time',
    'Booking Status',
    'Vehicle Reg Number',
    'Agent',
    'Customer Name',
  ];

  constructor(
    private supplierService: SupplierService,
    private route: ActivatedRoute,
    private router: Router,
    private driverService: DriverService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.supplierId = this.route.snapshot.paramMap.get('id');
    this.getSupplier();

    this.supplierService.supplierVehiclesOnChange.subscribe((res: any) => {
      console.log('Received data:', res);
      this.vehicles = res;
      this.updatePaginationData();
    });
  }

  updatePaginationData(): void {
    // Ensure currentPageIndex is within valid range
    if (this.currentPageIndex > this.totalPages) {
      this.currentPageIndex = this.totalPages;
    }

    // Calculate paginated vehicles
    const start = this.currentPageIndex * this.pageSizeVeh;
    const end = start + this.pageSizeVeh;
    this.paginatedVehicles = this.vehicles.slice(start, end);
    console.log('innn' + this.paginatedVehicles);
  }

  onPageIndexChange(pageIndex: number): void {
    this.currentPageIndex = pageIndex;
    this.updatePaginationData();
  }

  get totalPages(): number {
    return Math.ceil(this.vehicles.length / this.pageSizeVeh);
  }

  getSupplier(): void {
    this.supplierService.getSuppliersById(this.supplierId).then((res) => {
      this.note = res.notes.note;
      this.supplierData = res;
      console.log(this.supplierData);
      this.setBreadcrumbs();
      this.loading = false;
    });
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: ` Suppliers `,
        route: '/admin/suppliers',
      },
      {
        title: ` ${this.supplierData.supplierId} `,
      },
    ];
  }

  getPagedDrivers(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        supplierId: this.supplierId,
        searchValue: this.searchText,
      },
    });
    this.driverService.getPagedDriversBySupplier(payload).then((res: any) => {
      this.driverData = res.data;
      this.pageSize.length = res.totalItems;
      this.loading = false;
    });
  }

  showModal(image: string): void {
    this.selectedImage = image;
    this.isVisible = true;
  }

  handleCancel(): void {
    this.selectedImage = '';
    this.isVisible = false;
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedDrivers();
  }

  editNavigate(): void {
    const navigationExtras = {
      queryParams: {
        prev: 'single', // Replace 'your_value_here' with the actual value you want to pass
      },
    };
    this.router.navigate(
      [`admin/suppliers/add-edit/${this.supplierId}`],
      navigationExtras,
    );
  }

  search(): void {
    this.getPagedDrivers();
  }

  resetSearch(): void {
    this.searchText = null;
    this.getPagedDrivers();
  }

  navToSingleDriver(index: any): void {
    this.router.navigate([`/admin/drivers/${this.driverData[index]._id}`]);
  }

  displayVehicle(id: any): string {
    const foundVehicle = this.vehicles.find((vehicle) => vehicle._id === id);

    if (foundVehicle) {
      return foundVehicle.registerNumber;
    } else {
      return '-';
    }
  }

  //Add vehicle stuff
  isVisibleAddVehicleForm(): void {
    this.driverService.supplierVehicleFormType.next('add');
    this.isVisibleAddVehicle = true;
  }

  addVehicleOnChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.isVisibleAddVehicle = false;
        break;
      case 'submit':
        this.isVisibleAddVehicle = false;
        this.supplierService.getSuppliersById(this.supplierId).then((res) => {
          this.note = res.notes.note;
          this.supplierData = res;
        });
        break;
    }
  }

  getImage(imageObj: any, type: string): string {
    let imageUrl = 'assets/img/image-placeholder.png';
    if (imageObj?.attach) {
      if (imageObj?.type === type) {
        imageUrl = imageObj?.attach?.url;
      }
    }
    return imageUrl;
  }

  removeVehicleDetails(index: number): void {
    this.loading = true;
    this.vehicles.splice(index, 1);
    this.supplierService
      .updateSuppliers({
        _id: this.supplierId,
        vehicles: this.vehicles,
        updateType: 'vehicle_remove',
      })
      .then((res: any) => {
        this.message.create('success', `Vehicle has been removed!`);
        this.loading = false;
        this.getSupplier();
      });
  }

  cancel(): void {}

  editVehicle(index: number): void {
    this.supplierService.selectedVehicle.next(this.vehicles[index]);
    this.supplierService.selectedVehicleIndex.next(index);
    this.driverService.supplierVehicleFormType.next('edit');
    this.isVisibleAddVehicle = true;
  }

  resetSearchTour() {
    this.statusFilter = null;
    this.dateFilter = null;
    this.searchTextTour = null;
    this.getPagedBookings();
  }

  searchTour() {
    this.getPagedBookings();
  }

  getPagedBookings(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSizeTour), {
      sortField: this.sortFieldTour,
      sortOrder: this.sortOrderTour,
      filters: {
        searchValue: this.searchTextTour,
        status: this.statusFilter,
        dateFilter: this.dateFilter,
      },
      id: this.route.snapshot.paramMap.get('id'),
    });
    console.log(payload);
    this.supplierService.getSupplierBookings(payload).then((res: any) => {
      this.loading = false;
      this.bookingData = res.bookings;

      console.log(res.bookings);
      this.pageSizeTour.length = res.totalItems;
    });
  }

  onTableParamsChangeTour(params: NzTableQueryParams): void {
    this.pageSizeTour.pageSize = params.pageSize;
    this.pageSizeTour.pageIndex = params.pageIndex;
    this.getPagedBookings();
  }

  navigate(data: any): void {
    if (data.bookingType === 'rent') {
      this.router.navigate([`/admin/booking-rent/${data._id}`]);
    } else if (data.bookingType === 'other') {
      this.router.navigate([`admin/booking-other/${data._id}`]);
    } else {
      this.router.navigate([`admin/booking-transfer/${data._id}`]);
    }
  }

  onChangeDateFilter(result: Date[]): void {
    this.getPagedBookings();
  }

  nav(data: any, flag: any): void {
    if (flag === 'agent') {
    } else {
      this.router.navigate([`admin/customers/${data}`]);
    }
  }
}
